import { makeStyles } from '@material-ui/core';
export const useDrawerStyles = makeStyles({
  root: {
    '& .MuiDrawer-paper': {
      height: 'calc(100% - 50px)',
      //because of top bar
      top: '50px' // because of top bar
    }
  }
});